import React from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import { get } from 'lodash';
import Button from '@material-ui/core/Button';

function UploadImageForm(props) {
    const { label, setFile, previewImage, setPreviewImage, isOnlyImage, indexImg, removeImage } = props;

    const imagePreview = (preview, indexImg) => {
      const reader = new FileReader();
      reader.readAsDataURL(preview);
      reader.onloadend = () => {
        setPreviewImage(reader.result, indexImg);
      };
    };

    const handleOnChange = e => {
      const newFile = e.target.files[0];
      console.log('newFile', newFile);
      if (isOnlyImage) {
        const mineFile = get(newFile, 'type', '');
        if (mineFile.search('image/') >= 0) {
          setFile(newFile, indexImg);
          imagePreview(newFile, indexImg);
        } else {
          alert('画像の形式が正しくありま線。');
        }
      } else {
        setFile(newFile, indexImg);
        imagePreview(newFile, indexImg);
      }
      e.target.value = null;
    };

    return (
      <div className="uploadFile">
        <InputLabel
          htmlFor={label}
          margin="dense"
          className="inputLabel"
        >
          <Button
            variant="outlined"
            color="primary"
            component="span"
            className="button"
            >
            画像アップロード
          </Button>
          <Button 
            onClick={() => removeImage(indexImg)} 
            color="secondary">
            クリア
          </Button>
        </InputLabel>
        {previewImage && (
          <Card className="image">
            <CardActionArea>
              <CardMedia component="img" image={previewImage} />
            </CardActionArea>
          </Card>
        )}

        <input
          id={label}
          type="file"
          accept="image/*"
          className="inputImage"
          onChange={e => handleOnChange(e)}
        />
      </div>
    );
  }

export default UploadImageForm;